export default "__VITE_ASSET__CXui3vmJ__"